import { useState } from '#imports'
import { onMounted } from 'vue'

import type { GetOfferV1Response } from '@backmarket/http-api/src/api-specs-buyback/customer/getOfferV1'
import { useLocalStorage } from '@backmarket/utils/composables/useLocalStorage'

export function useBuybackFunnelOffer() {
  const offer = useState<GetOfferV1Response | null>(
    'buyback-funnel-offer',
    () => null,
  )
  const localStorage = useLocalStorage()

  function resetBuyBackOffer() {
    offer.value = null
    localStorage.removeItem('buyback_offer')
  }

  function setBuyBackOffer(newOffer: GetOfferV1Response) {
    offer.value = newOffer

    localStorage.setItem('buyback_offer', JSON.stringify(newOffer))
  }

  onMounted(() => {
    const storedOffer = localStorage.getItem('buyback_offer')

    offer.value = storedOffer ? JSON.parse(storedOffer) : null

    // !offer.value.listing is a temporary fix to prevent the offer page from showing
    // when customer has legacy offer in local storage
    if (offer.value && !offer.value.listing) {
      resetBuyBackOffer()
    }
  })

  return {
    offer,
    resetBuyBackOffer,
    setBuyBackOffer,
  }
}
